import React, { Component } from 'react';
import get from 'lodash/get';

import DateofBirth from '../DateOfBirth';

import WidgetPropTypes from '../types';
import Button from '../../../components/UI/Button/index.tsx';
import css from './ProvePrefill.module.scss';

export const WIDGET_NAME = 'prove_prefill';
const isProvePrefillStandaloneQuestion = questions =>
  questions && questions.length === 1 && questions[0] === WIDGET_NAME;

class ProvePrefillQuestion extends Component {
  constructor() {
    super();

    this.state = {
      answer: '',
      enableNextButton: false
    };
    this.dobWidget = null;
    this.setDobWidgetRef = element => {
      this.dobWidget = element;
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.segment.page('Registration', 'Prove Prefill');
    this.props.analytics.trackEvent('Registration Send Card Viewed');
    this.props.analytics.trackEvent('Registration DOB Viewed', {
      eventProps: {
        role: get(this.props, 'app.answers.setRole')
      }
    });
  }

  errorChecking = async () => {
    const proveStandalone = isProvePrefillStandaloneQuestion(
      this.props.questions
    );
    try {
      if (
        this.dobWidget &&
        typeof this.dobWidget.errorChecking === 'function'
      ) {
        await this.dobWidget.errorChecking();
      }
      // If prove_prefill is by itself fire event and answer
      if (proveStandalone) {
        this.props.analytics.trackEvent('Prove Prefill Accepted');
        this.props.answer({
          accessToken: this.props.app.registrationToken,
          questions: [WIDGET_NAME],
          answers: [{ dob: this.state.answer }]
        });
      }
    } catch (error) {
      window.scrollTo(0, 0);
      // If widget isn't standalone, we need to throw an error for WidgetWrapper checkErrors to catch
      if (!proveStandalone) {
        throw new Error();
      }
    }
  };

  skipPrefill = () => {
    this.props.analytics.trackEvent('Prove Prefill Declined');
    this.props.answer({
      accessToken: this.props.app.registrationToken,
      questions: [WIDGET_NAME],
      answers: [{ skipPrefill: true }]
    });
  };

  onEnableChanged = (question, enabled) => {
    this.setState({ enableNextButton: enabled });
    this.props.shouldEnable(WIDGET_NAME, enabled);
  };

  onAnswerChanged = (question, answer) => {
    this.setState({ answer });
    this.props.changeAnswerValue(WIDGET_NAME, { dob: answer });
  };

  onKeyDown = event => {
    if (event.key === 'Enter' && this.state.enableNextButton) {
      const proveStandalone = isProvePrefillStandaloneQuestion(
        this.props.questions
      );

      if (proveStandalone) {
        event.preventDefault();
        event.stopPropagation();
        this.errorChecking();
      }
    }
  };

  render() {
    const { index, onClick, widget, questions } = this.props;
    const proveStandalone = isProvePrefillStandaloneQuestion(questions);

    return (
      <div className={css.provePrefill} onKeyDown={this.onKeyDown}>
        {proveStandalone && (
          <h2
            data-e2e="prove-prefill-question-subheader"
            data-testid="prove-prefill-question-subheader"
          >
            We can pre-fill your information by confirming your date of birth.
          </h2>
        )}
        <DateofBirth
          changeAnswerValue={this.onAnswerChanged}
          index={index}
          onClick={onClick}
          shouldEnable={this.onEnableChanged}
          widget={widget}
          ref={this.setDobWidgetRef}
          createError={this.props.createError}
          app={this.props.app}
          analytics={this.props.analytics}
        />
        {proveStandalone && (
          <>
            <Button
              text="Next"
              loading={this.props.app.loading}
              onClick={this.errorChecking}
              disabled={!this.state.enableNextButton}
            />
            <p
              onClick={this.skipPrefill}
              className={css.provePrefillSecondaryButton}
              data-e2e="decline-prove-prefill"
              data-testid="decline-prove-prefill"
            >
              No thanks. I’ll input my information manually.
            </p>
          </>
        )}
        <p className={css.legalText}>
          By entering your date of birth and selecting "Next," you acknowledge
          that Greenlight has partnered with a digital identity company to help
          pre-fill your information through authenticated sources. You will have
          an opportunity to correct any element of information that might be
          inaccurate on the following screen.
        </p>
      </div>
    );
  }
}

ProvePrefillQuestion.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default ProvePrefillQuestion;
